export default __webpack_public_path__ + "static/media/enclosure.413577ba.webp";